import React from 'react';
import Conditional from '../../common/conditional';

import classNames from './style.module.scss';

interface NoItemsProps {
	isVisible: boolean;
	onRefresh: () => void;
}

const NoItems: React.FC<NoItemsProps> = (props): JSX.Element => {
	return (
		<Conditional isVisible={props.isVisible}>
			<div className={classNames.noItems}>
				<div className='d-flex flex-column justify-content-center align-items-center bg-white p-3 border rounded w-100'>
					<div className={classNames.noItemsLabel}>No items to show</div>
					<div className={classNames.noItemsIcon}><i className="bi bi-arrow-clockwise"></i></div>
					<button onClick={props.onRefresh} className={classNames.noItemsButton}>
						Tap to refresh
					</button>
				</div>
			</div>
		</Conditional>
	);
};

export default NoItems;
